import { Paper, styled } from '@mui/material';
export var JoveGridItem = styled(Paper)(function () {
  return {
    backgroundColor: 'transparent',
    boxShadow: 'none'
  };
});